// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
// import Badge from "@insite/mobius/Badge"; // Starter Custom Code
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useState } from "react";
import { css } from "styled-components";

/* Starter Custom Code */
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import Badge from "@store/MobiusOverrides/Badge/Badge";
import { badgeProps } from "@store/Themes/common/props/badge";
/* Starter Custom Code */

/* Store Custom Code */
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";

interface Props {
    badgeList: BadgeModel[];
    maxBadges: number;
    extendedStyles?: ProductTextBadgesStyles;
}

export interface ProductTextBadgesStyles {
    container?: InjectableCss;
    badge?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    // Starter Custom Code
    tagWrapper?: TagWrapperProps;
}

export const productTextBadgesStyles: ProductTextBadgesStyles = {
    tagWrapper: badgeProps.tagWrapper,
    badgeText: badgeProps.badgeText,
};

const ProductTextBadges = ({ badgeList, maxBadges, extendedStyles }: Props) => {
    // Store Custom Code - useMergeProps allows for dynamic styles where as the useState version does not
    const styles = useMergeProps(productTextBadgesStyles, extendedStyles);
    return (
        <TagWrapper {...styles.tagWrapper} data-test-selector="textBadges" /* Starter Custom Code */>
            {badgeList.slice(0, maxBadges).map(badge => (
                /* Starter Removed - StyledWrapper */
                <Badge
                    key={badge.id} // Starter Custom Code
                    type={badge.badgeType}
                    value={badge.displayText}
                    badgeTextColor={badge.textColorHexCode}
                    badgeBackgroundColor={badge.badgeColorHexCode}
                    badgeTextRounding={badge.badgeStyle === "Round"} // Starter Custom Code
                    textBadgeCss={styles.badgeText}
                    {...styles.badge}
                />
            ))}
        </TagWrapper>
    );
};

export default ProductTextBadges;
